// @flow

import createApiModule from "../create-api-module";

const { reducer, actions } = createApiModule(
    "embedRetoolOrganisation",
    ({ uuid }) =>
        `ays-organisation-management/organisations/${uuid}/embedded-retool-url`,
    {
        method: "get",
    },
);

const load = (uuid: string) => (dispatch: *) => {
    return dispatch(
        actions.load(
            {
                data: { appName: "admin" },
                path: {
                    uuid,
                },
            },
            true,
        ),
    );
};
const refetch = actions.refetch;
const clear = actions.clear;
const ERROR = "Could not fetch embed retool uri";

export { reducer as default, load, refetch, clear, ERROR };
